import { Paper } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { formatItem, formatPenalty } from "@framework/exchange";
import type { IPonziRule } from "@framework/types";
import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Table } from "@dzambalaorg/ui-kit";

import { normalizeDuration } from "../../../../../../utils/time";

export interface IPonziDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IPonziRule | null;
}

export const PonziDialogView = (props: IPonziDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { title, description, deposit, reward, durationAmount, durationUnit, penalty } = viewItem;

  const { formatMessage } = useIntl();

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="ponzi rules table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.title" />
              </Table.Cell>
              <Table.Cell align="right">{title}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.description" />
              </Table.Cell>
              <Table.Cell align="right">
                <RichTextDisplay data={description} />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.deposit" />
              </Table.Cell>
              <Table.Cell align="right">{formatItem(deposit)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.reward" />
              </Table.Cell>
              <Table.Cell align="right">{formatItem(reward)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.durationAmount" />
              </Table.Cell>
              <Table.Cell align="right">
                {formatMessage(
                  { id: `enums.durationUnit.${durationUnit}` },
                  { count: normalizeDuration({ durationAmount, durationUnit }) },
                )}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.penalty" />
              </Table.Cell>
              <Table.Cell align="right">{formatPenalty(penalty)}%</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
